/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  items: [],
  meta: {
    current_page: 1,
    first_page_url: '',
    from: 1,
    last_page: 3,
    last_page_url: '',
    links: [],
    next_page_url: '',
    path: '',
    per_page: 20,
    prev_page_url: null,
    to: 20,
    total: 0
  }
}
